import React, { useEffect } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import {
  AdminUiMode,
  legacyV2ToCanonical,
  switchPathToCanonical,
  toV2Href,
  writeAdminUiMode,
} from './adminUiRoutes';

/** Vecchi indirizzi -v2: reindirizza all'indirizzo ufficiale, query e hash inclusi. */
export const LegacyV2Redirect: React.FC = () => {
  const loc = useLocation();
  const to = legacyV2ToCanonical(loc.pathname) || '/admin';
  return <Navigate to={to + loc.search + loc.hash} replace />;
};

/**
 * /admin/classica[/...] e /admin/nuova[/...]: memorizza la modalità scelta e
 * torna allo stesso indirizzo ufficiale. Nessun contenuto proprio.
 */
export const AdminUiSwitch: React.FC<{ mode: AdminUiMode; onChange: (mode: AdminUiMode) => void }> = ({ mode, onChange }) => {
  const loc = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    writeAdminUiMode(mode);
    onChange(mode);
    navigate(switchPathToCanonical(loc.pathname) + loc.search + loc.hash, { replace: true });
    // Esegue una sola volta per ogni ingresso nell'interruttore
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc.key]);

  return null;
};

/**
 * Nella modalità classica: pillola fissa per tornare alla nuova interfaccia
 * restando sulla stessa pagina. In basso a sinistra per non coprire la bolla
 * dell'assistente, che sta a destra.
 */
export const ClassicModeReturnPill: React.FC = () => {
  const loc = useLocation();
  return (
    <Link
      to={toV2Href(loc.pathname) + loc.search}
      className="fixed bottom-4 left-4 z-50 inline-flex items-center gap-2 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium px-4 py-2 shadow-lg transition-colors"
      title="Torna alla nuova interfaccia di amministrazione"
    >
      <span className="inline-block w-2 h-2 rounded-full bg-white/80" />
      Passa alla nuova interfaccia
    </Link>
  );
};
